import GeneratingKeyPairsLinux from "../../../../src/courses/partials/ssh/linux/generating-key-pairs.mdx";
import * as React from 'react';
export default {
  GeneratingKeyPairsLinux,
  React
};